//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    autoHeight: {
      type: Boolean,
      default: false
    },
    gutter: {
      type: Number,
      default: 13
    }
  },
  name: 'baseLayoutRow'
}



// WEBPACK FOOTER //
// ./src/components/baseLayout/baseLayoutRow.vue